const bookingHighlights = [
  { metric: 'Active requests', value: '32', detail: 'Waiting for agent assignment' },
  { metric: 'Completed', value: '128', detail: 'This week' },
  { metric: 'New in queue', value: '6', detail: '24h response goal' },
];

const bookingHistory = [
  { title: 'Care package · CW-2049', status: 'Confirmed', time: 'Yesterday · 4:10 PM' },
  { title: 'Medication review · CW-2052', status: 'Pending', time: 'Jan 22 · 9:00 AM' },
  { title: 'Support follow-up · CW-2058', status: 'Completed', time: 'Jan 21 · 2:45 PM' },
];

function BookingsPage() {
  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Care jobs</p>
        <h1 className="text-3xl font-semibold text-slate-900">Booking overview</h1>
        <p className="text-slate-600">
          Track every caregiver booking and make sure payment and task details stay visible to the team.
        </p>
      </header>
      <section className="grid gap-4 md:grid-cols-3">
        {bookingHighlights.map((highlight) => (
          <article
            key={highlight.metric}
            className="rounded-3xl border border-emerald-100 bg-white px-5 py-6 shadow-sm shadow-slate-200"
          >
            <p className="text-xs uppercase tracking-[0.4em] text-emerald-500">{highlight.metric}</p>
            <p className="mt-3 text-3xl font-semibold text-slate-900">{highlight.value}</p>
            <p className="text-sm text-slate-500">{highlight.detail}</p>
          </article>
        ))}
      </section>
      <section className="rounded-3xl border border-emerald-100 bg-slate-50/70 p-6 shadow-lg shadow-emerald-200">
        <h2 className="text-lg font-semibold text-slate-900">Recent bookings</h2>
        <div className="mt-4 space-y-3">
          {bookingHistory.map((booking) => (
            <article
              key={booking.title}
              className="flex items-center justify-between rounded-2xl border border-emerald-100 bg-white px-4 py-3 shadow-sm shadow-slate-100"
            >
              <div>
                <p className="text-base font-semibold text-slate-900">{booking.title}</p>
                <p className="text-xs text-slate-500">{booking.time}</p>
              </div>
              <span
                className={`rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.3em] ${
                  booking.status === 'Confirmed'
                    ? 'bg-emerald-100 text-emerald-600'
                    : booking.status === 'Pending'
                    ? 'bg-amber-100 text-amber-600'
                    : 'bg-slate-100 text-slate-600'
                }`}
              >
                {booking.status}
              </span>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default BookingsPage;
